import React, { useState } from 'react';
import { DisputeResolution } from '../../types/dispute';
import './ResolveDisputeForm.css';

interface ResolveDisputeFormProps {
  onResolve: (resolution: string, notes: string) => Promise<void>;
}

const ResolveDisputeForm: React.FC<ResolveDisputeFormProps> = ({ onResolve }) => {
  const [resolution, setResolution] = useState<string>(DisputeResolution.RefundToBuyer);
  const [notes, setNotes] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    setIsSubmitting(true);
    try {
      await onResolve(resolution, notes);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <div className="resolve-dispute-form-container">
      <form onSubmit={handleSubmit}>
        <div className="resolve-dispute-form-group">
          <label>Resolution:</label>
          <div className="resolve-dispute-form-radio-group">
            <label>
              <input
                type="radio"
                name="resolution"
                value={DisputeResolution.RefundToBuyer}
                checked={resolution === DisputeResolution.RefundToBuyer}
                onChange={() => setResolution(DisputeResolution.RefundToBuyer)}
              />
              Refund to Buyer
            </label>
            <label>
              <input
                type="radio"
                name="resolution"
                value={DisputeResolution.ReleaseToSeller}
                checked={resolution === DisputeResolution.ReleaseToSeller}
                onChange={() => setResolution(DisputeResolution.ReleaseToSeller)}
              />
              Release to Seller
            </label>
          </div>
        </div>
        
        <div className="resolve-dispute-form-group">
          <label htmlFor="notes">Notes:</label>
          <textarea
            id="notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Provide resolution notes..."
            maxLength={1000}
            rows={4}
            className="resolve-dispute-form-textarea"
          />
        </div>
        
        <button type="submit" className="resolve-dispute-form-btn-warning" disabled={isSubmitting}>
          {isSubmitting ? 'Resolving...' : 'Resolve Dispute'}
        </button>
      </form>
    </div>
  );
};

export default ResolveDisputeForm;